<template>
	<v-container style="background-color: #ffffff">
		<p class="text-center" style="font-size: 16px; margin-left: 10px;">Under this tab, you'll find all the actively using risk matrices. </p>
		<div class="matrix">
			<v-spacer></v-spacer>
			<v-btn class="matrix-btn" color="primary" @click="seecount">
				Create a risk matrix
			</v-btn>
		</div>
		<v-col cols="12" class="pt-8">
			<v-card elevation="0" outlined>
				<v-data-table
					ref="dataTable"
					:loading="loading"
					theme
					light
					:headers="headers"
					:items="items"
					:footer-props="{
						'items-per-page-options': [5, 10, 15],
					}"
					:items-per-page="5"
					class="light table"
					@click:row="selectRow"
				>
					<template v-slot:item="{ item, index }">
						<tr
							:class="{ 'selected-row': selectedRowIndex === index }"
							@click="selectRow(item, index)"
						>
							<td>{{ item.Title }}</td>
							<td>
								<span style="padding-left: 	15px;">{{ item.Year }}</span>
							</td>
							<td>
								<span
									v-if="item.Status === 'Active'"
									class="success--text font-weight-bold"
									style="padding-left: 	15px;"
									>Active</span
								>
								<span v-else class="error--text font-italic font-weight-bold"
									>Inactive</span
								>
							</td>
							<td>
								<v-btn
									small
									color="primary"
									style="border-radius: 2px"
									@click.stop="editItem(item)"
								>
									<v-icon small>fas fa-edit</v-icon>
								</v-btn>
							</td>
							<td>
								<v-btn
									v-on:click="makeitInactive(item)"
									v-if="item.Status === 'Active'"
									class="error--text font-italic font-weight-bold"
									>Deactivate</v-btn
								>
								<v-btn
									v-on:click="makeitActive(item)"
									v-else
									class="success--text font-weight-bold"
									>Activate</v-btn
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-card>
		</v-col>
		<div class="toplayermargin" ref="riskMatrixPoint">
			<Riskmatrixwithpoint />
		</div>
		<div>
			<Riskmatrixwithtable />
		</div>
		<br />
		<br />
		<div>
			<ActionPlanRisk />
		</div>
		<br />
		<div style="display: flex; justify-content: center;">
			<v-btn class="complete-btn" color="primary" @click="makeitComplete()" :disabled="isButtonDisabled">
				Complete
			</v-btn>
		</div>
		<v-dialog v-model="dialog" max-width="600" @input="onDialogChange">
			<v-card>
				<v-card-title>
					<span class="headline123">Create a Risk Matrix</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						label="Matrix Name"
						v-model="newMatrixTitle"
						required
					></v-text-field>
					<v-select
						label="Year"
						v-model="newMatrixYear"
						:items="EsgYear"
						required
					></v-select>
					<v-textarea
						label="Description"
						v-model="newMatrixDescription"
						required
					></v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="resetNewMatrixForm">Cancel</v-btn>
					<v-btn
						color="primary"
						text
						@click="createRiskMatrix"
						:disabled="isCreateButtonDisabled"
						>Create</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialog2" max-width="600">
			<v-card>
				<v-card-title>
					<span class="headline123">Update Risk Matrix</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						label="Matrix Name"
						v-model="updateMatrixTitle"
						required
					></v-text-field>
					<v-select
						label="Year"
						v-model="updateMatrixYear"
						required
						:items="EsgYear"
					></v-select>
					<v-textarea
						label="Description"
						v-model="updateMatrixDescription"
					></v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialog2 = false">Cancel</v-btn>
					<v-btn color="primary" text @click="updateRiskMatrix">Update</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogComplete" max-width="550px">
			<v-card class="d-flex flex-column align-center justify-center">
				<v-card-title class="text-center">
					Success! Your risk matrix is moved to completed tab
				</v-card-title>

				<v-card-actions class="justify-center">
					<v-btn color="primary" text @click="CompleteRow">OK</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogExceed" max-width="600" @input="onDialogChange">
			<v-card>
				<v-card-title
					class="text-center"
					style="font-weight: bold; font-size: 18px; color: #1e7c83;"
				>
					You have Reached the Maximum Amount of Risk Matrixs that can Create
					for this Package
				</v-card-title>
				<v-card-text
					class="text-center"
					style="color: #757575; font-size: 16px; margin-top: 10px;"
				>
					Please upgrade your current plan to create a risk matrix.
				</v-card-text>
				<v-card-actions style="justify-content: center; margin-top: 20px;">
					<v-btn color="secondary" text>Cancel</v-btn>
					<v-btn color="primary" text style="font-weight: bold;">Upgrade</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Riskmatrixwithpoint from "../components/Riskmatrixwithpoint.vue"
import Riskmatrixwithtable from "../components/Riskmatrixwithtable.vue"
import ActionPlanRisk from "../components/ActionPlanRisk.vue"
import LoadingState from "../consts/LoadingState"
import { riskmatrixAPI } from "../api/csr/riskmatrix"
import { mapGetters } from "vuex"
export default {
	components: {
		Riskmatrixwithpoint,
		ActionPlanRisk,
		Riskmatrixwithtable,
	},
	data() {
		return {
			dialog: false,
			dialog2: false,
			createstate: false,
			hasScrolled: false,
			dialogComplete: false,
			dialogExceed: false,
			items: [],
			EsgYear: [],
			selectedRowIndex: null,
			updateMatrixTitle: "",
			updateMatrixYear: "",
			updateMatrixDescription: "",
			currentMatrixId: null,
			currentMatrixTitle: "",
			currentMatrixYear: "",
			currentMatrixDescription: "",
			updateMatrixId: null,
			newMatrixId: null,
			newMatrixTitle: "",
			newMatrixYear: "",
			newMatrixDescription: "",
			count: null,
			headers: [
				{
					text: "Title",
					value: "title",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Date",
					value: "date",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Status",
					value: "active",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Edit",
					value: "edit",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Deactivate",
					value: "remove",
					sortable: false,
					class: "darkColor--text",
				},
			],
		}
	},
	watch: {
		"$store.getters.selectedStatus": {
			immediate: true,
			handler(newStatus) {
				if (newStatus === "Active") {
					console.log("dfgd", this.count)
					this.$store.commit("setSelectedId", null)
					this.$store.commit("setSelectedTitle", "")
					this.$store.commit("setSelectedDescription", "")
					this.loadItems()
					console.log("dfgd", this.count)
					this.loadcount()
					console.log("dfgd", this.count)

					this.hasScrolled = false
				}
			},
		},
	},
	computed: {
		...mapGetters([
			"selectedId",
		]),
		isCreateButtonDisabled() {
			const trimmedTitle = this.newMatrixTitle ? this.newMatrixTitle.trim() : ""
			const trimmedDescription = this.newMatrixDescription
				? this.newMatrixDescription.trim()
				: ""
			return !trimmedTitle || !this.newMatrixYear || !trimmedDescription
		},
		isButtonDisabled() {
			return this.selectedId === null
		},
	},
	mounted() {
		this.$store.commit("setSelectedId", null)
		this.$store.commit("setSelectedTitle", "")
		this.$store.commit("setSelectedDescription", "")
		const currentYear = new Date().getFullYear()
		for (let year = currentYear; year >= currentYear - 5; year--) {
			this.EsgYear.push(year)
		}
	},
	methods: {
		async createRiskMatrix() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			try {
				await riskmatrixAPI.createRisk(
					this.newMatrixTitle,
					this.newMatrixDescription,
					this.newMatrixYear,
					"Active"
				)
				this.createstate = true
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
			this.$store.commit("setCreateMatrix", false)
			this.dialog = false
			this.reloadComponent()
		},
		async updateRiskMatrix() {
			try {
				await riskmatrixAPI.updateRiskById(
					this.updateMatrixId,
					this.updateMatrixTitle,
					this.updateMatrixDescription,
					this.updateMatrixYear,
					"Active"
				)
				this.dialog2 = false
				this.reloadComponent()
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			this.loadcount()
			riskmatrixAPI
				.getAll("Active")
				.then((data) => {
					this.items = data[0]
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					if (this.items.length > 0) {
						const mostRecentItem = this.items.reduce((prev, current) => {
							return new Date(prev.Created) > new Date(current.Created)
								? prev
								: current
						})
						const mostRecentItemIndex = this.items.findIndex(
							(item) => item === mostRecentItem
						)
						if (this.$store.getters.selectedNewstate) {
							this.selectRow(
								this.$store.getters.selectedItem,
								this.$store.getters.selectedIndex
							)
						} else if (this.createstate) {
							this.selectRow(mostRecentItem, mostRecentItemIndex)
						} else {
							this.selectRow(this.items[0], 0)
						}
						this.$store.commit("setSelectedNewstate", false)
						this.createstate = false
						console.log("dfgd", this.count)
					}
					console.log("dfgd", this.count)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		selectRow(item, index) {
			this.selectedRowIndex = index
			this.newMatrixId = item.ID
			this.currentMatrixId = item.ID
			this.currentMatrixTitle = item.Title
			this.currentMatrixDescription = item.Description
			this.currentMatrixYear = item.Year
			this.$store.commit("setSelectedId", item.ID)
			this.$store.commit("setSelectedTitle", item.Title)
			this.$store.commit("setSelectedDescription", item.Description)
			this.$store.commit("setSelectedItem", item)
			this.$store.commit("setSelectedIndex", index)
			// Scroll to the Riskmatrixwithpoint component with an offset, only on row click
			if (this.hasScrolled) {
				const element = this.$refs.riskMatrixPoint
				if (element) {
					const offset = 100 // Adjust this value to fine-tune the scroll distance
					const elementPosition =
						element.getBoundingClientRect().top + window.scrollY
					const scrollToPosition = elementPosition - offset
					window.scrollTo({ top: scrollToPosition, behavior: "smooth" })
				}
			} else {
				this.hasScrolled = true
			}
		},
		editItem(item) {
			this.updateMatrixId = item.ID
			this.updateMatrixTitle = item.Title
			this.updateMatrixYear = item.Year
			this.updateMatrixDescription = item.Description
			this.dialog2 = true
		},
		loadcount() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			riskmatrixAPI
				.getCount()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.count = data[0]
					if (data[0] >= 10) {
						this.dialogExceed = this.$store.getters.createMatrix
					} else {
						this.dialog = this.$store.getters.createMatrix
					}
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		seecount() {
			if (this.count >= 10) {
				this.dialogExceed = true
			} else {
				this.dialog = true
			}
		},
		reloadComponent() {
			this.hasScrolled = false
			this.loadItems()
			this.newMatrixTitle = ""
			this.newMatrixDescription = ""
			this.newMatrixYear = ""
		},
		resetNewMatrixForm() {
			this.newMatrixTitle = null
			this.newMatrixYear = null
			this.newMatrixDescription = null
			this.dialog = false
			this.$store.commit("setCreateMatrix", false)
		},
		onDialogChange(value) {
			if (!value) {
				this.$store.commit("setCreateMatrix", false)
				this.resetNewMatrixForm()
			}
		},
		async makeitInactive(item) {
			this.hasScrolled = false
			try {
				await riskmatrixAPI.updateRiskById(
					item.ID,
					item.Title,
					item.Description,
					item.Year,
					"Inactive"
				)
				this.$store.commit("setSelectedId", null)
				this.$store.commit("setSelectedTitle", "")
				this.$store.commit("setSelectedDescription", "")
				this.reloadComponent()
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		async makeitComplete() {
			try {
				await riskmatrixAPI.updateRiskById(
					this.currentMatrixId,
					this.currentMatrixTitle,
					this.currentMatrixDescription,
					this.currentMatrixYear,
					"Completed"
				)
				this.dialogComplete = true
				this.$store.commit("setSelectedId", null)
				this.$store.commit("setSelectedTitle", "")
				this.$store.commit("setSelectedDescription", "")
				this.reloadComponent()
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		CompleteRow() {
			this.dialogComplete = false
			this.reloadComponent()
			this.$nextTick(() => {
				const tableElement = this.$refs.dataTable?.$el || this.$refs.dataTable
				if (tableElement) {
					tableElement.scrollIntoView({ behavior: "smooth" })
				}
			})
		},
	},
}
</script>

<style>
.toplayermargin {
	margin-top: 0px;
	transform: scale(0.8);
}

.matrix {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.matrix-btn {
	margin-right: 40px;
	margin-bottom: 20px;
}

.headline123 {
	margin-left: 180px;
	color: #1e7c83;
	font: inherit !important;
	font-weight: bolder !important;
}

.selected-row {
	background: #e0e0e0 !important;
}
</style>
